import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateUserAvatarParams {
	readonly avatarUrl: string;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserAvatarApiMutation extends ApiMutation<
	UserOutput,
	UpdateUserAvatarParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateUserAvatar($avatarUrl: String!) {
			updateUserAvatar(avatarUrl: $avatarUrl) {
				...User
			}
		}
		${user}
	`;
	method = 'updateUserAvatar';
}
